import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import ThaiBahtText from "thai-baht-text";

import { report_contract } from "../components/Report.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      warehouse_name: "",
      transaction_list: [],
      amount: 0,
      amount_deposit: 0,
      total_pay: 0,
    };
  }

  async componentDidMount() {
    loading(false);

    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    // window.print();
  }
  Get = async (uid) => {
    loading(true);
    
    loading(false);
  };
  render() {
    const {
      document_no,
      created_at,
      customer_name,
      warehouse_name,
      transaction_list,
      amount,
      amount_deposit,
      total_pay,
    } = this.state;
    return (
      // <div
      //   className="mx-auto bg-white pdf"
      //   style={{ width: 1116, height: 1579, padding: "43px 78px" }}
      // >
      //   <h2 className="fw-bold text-center mb-4">
      //     ใบสัญญายืมหรือซื้อสินค้าชั่วคราว
      //   </h2>

      //   <h5 className="fw-bold mb-2">เลขที่เอกสาร : {document_no}</h5>
      //   <h5 className="fw-bold mb-4">
      //     วันที่ : {format_date(created_at, "dd mmmm yyyy", "th")}
      //   </h5>
      //   <div className="position-relative">
      //     <h5 className="mb-4" style={{ lineHeight: 2 }}>
      //       ข้าพเจ้า (ห้างร้าน,
      //       ตัวแทน)....................................................................ได้ยืมสินค้าจาก...................................................................................................
      //       ไปในสภาพเรียบร้อย และไม่มีสิ่งใดชำรุดบกพร่องแต่ประการใด ภายใน 5 วัน
      //       หากไม่ได้นำสินค้ามาคืนตามสภาพเดิม ถือว่าได้ซื้อสินค้านั้นไป
      //       จะต้องชำระเงินตามรายการข้างล่างดังกล่าวนี้ ไม่ว่ากรณีใด ๆ
      //     </h5>
      //     <h5 className="position-absolute" style={{ top: 4, left: 220 }}>
      //       {customer_name}
      //     </h5>
      //     <h5 className="position-absolute" style={{ top: 4, left: 540 }}>
      //       ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)
      //     </h5>
      //   </div>
      //   <table className="table table-bordered mb-4 text-18">
      //     <thead>
      //       <tr className="fw-bold border-0">
      //         <td className="text-center border-1 wpx-70">จำนวน</td>
      //         <td className="text-center border-1">รายการ</td>
      //         <td className="text-center border-1 wpx-150">ราคาต่อหน่วย</td>
      //         <td className="text-center border-1 wpx-150">จำนวนเงิน</td>
      //       </tr>
      //     </thead>
      //     <tbody>
      //       {transaction_list.map((item, index) => (
      //         <tr className="border-0">
      //           <td className="text-center" style={{ border: "0px 1px" }}>
      //             {index + 1}
      //           </td>
      //           <td className="text-start" style={{ border: "0px 1px" }}>
      //             {item.product_code} {item.product_name} {item.remark}
      //           </td>
      //           <td className="text-end" style={{ border: "0px 1px" }}>
      //             {toFixed(item.unit_price)}
      //           </td>
      //           <td className="text-end" style={{ border: "0px 1px" }}>
      //             {toFixed(Number(item.qty) * Number(item.unit_price))}
      //           </td>
      //         </tr>
      //       ))}
      //     </tbody>
      //     <tfoot>
      //       <tr className="border-0">
      //         <td className="fw-bold text-start border-1" colSpan={3}>
      //           รวมยอด ({ThaiBahtText(Number(amount))})
      //         </td>
      //         <td className="text-end border-1">{toFixed(amount)}</td>
      //       </tr>
      //       <tr className="border-0">
      //         <td className="text-start border-1" colSpan={4}>
      //           กรุณาตรวจดูสินค้าให้เรียบร้อยก่อน ถ้าพ้นกําหนด 5 วัน <br />
      //           ทางร้านจะไม่รับผิดชอบ ไม่ว่ากรณีใดๆ ทั้งสิ้น <br />
      //           และท่านจะต้องชําระค่าสินค้าตามสัญญาฯ นี้ทุกประการ
      //         </td>
      //       </tr>
      //     </tfoot>
      //   </table>

      //   <h5 className="mb-4" style={{ lineHeight: 2, textIndent: 50 }}>
      //     ข้าพเจ้าได้อ่านสัญญายืมสินค้าและซื้อสินค้าชั่วคราวนี้ดีแล้ว
      //     และยินดีชำระเงินตามรายการสินค้าตามรายการข้างต้นนี้ <br />
      //     จึงลงลายมือชื่อนี้เป็นสำคัญต่อหน้าพยาน
      //   </h5>
      //   <div className="fw-bold d-flex pt-5">
      //     <div className="text-center me-5">
      //       <div className="position-relative">
      //         <h5 className="mb-4">
      //           วันที่.............................................เลขที่เช็ค........................................
      //         </h5>
      //         <h5
      //           className="position-absolute"
      //           style={{ top: -2 - 2, left: 50 }}
      //         >
      //           {format_date(params("credit_date"))}
      //         </h5>
      //         <h5
      //           className="position-absolute"
      //           style={{ top: -2 - 2, left: 290 }}
      //         >
      //           {params("check_number")}
      //         </h5>
      //       </div>
      //       <div className="position-relative">
      //         <h5 className="mb-4">
      //           ธนาคาร............................................สาขา.........................................
      //         </h5>
      //         <h5
      //           className="position-absolute"
      //           style={{ top: -2 - 2, left: 70 }}
      //         >
      //           {params("credit_bank_account")}
      //         </h5>
      //         <h5
      //           className="position-absolute"
      //           style={{ top: -2 - 2, left: 290 }}
      //         >
      //           {"-"}
      //         </h5>
      //       </div>
      //       <div className="position-relative">
      //         <h5 className="mb-4">
      //           จำนวนเงิน..........................................................................................
      //         </h5>
      //         <h5
      //           className="position-absolute"
      //           style={{ top: -2 - 2, left: 90 }}
      //         >
      //           {toFixed(Number(params("credit_amount")))}
      //         </h5>
      //       </div>
      //       <div className="position-relative">
      //         <h5 className="mb-4">
      //           ลงชื่อผู้จ่ายเช็ค..................................................................................
      //         </h5>
      //       </div>
      //     </div>
      //     <div>
      //       <h5 className="mb-4">
      //         ลงชื่อ.................................................ผู้ยืมสินค้าหรือรับสินค้า
      //       </h5>
      //       <h5 className="ms-4 mb-4">
      //         (......................................................)
      //       </h5>
      //       <h5 className="mb-4">
      //         ลงชื่อ.................................................ผู้ให้ยืมสินค้า
      //       </h5>
      //       <h5 className="ms-4 mb-4">
      //         (......................................................)
      //       </h5>
      //       <h5 className="mb-4">
      //         ลงชื่อ.................................................พยาน
      //       </h5>
      //       <h5 className="mb-4">
      //         ลงชื่อ.................................................พยาน
      //       </h5>
      //     </div>
      //   </div>
      //   <div className="d-flex text-start">
      //     <h5 className="mb-4 me-3" style={{ lineHeight: 2 }}>
      //       หมายเหตุ
      //     </h5>
      //     <h5 className="mb-4" style={{ lineHeight: 2 }}>
      //       หากเป็นกรณีชำระด้วยเช็ค หากไม่สามารถเรียกเก็บเงินตามเช็คได้
      //       ไม่ว่ากรณีได ๆ ข้าพเจ้ายอมรับผิด
      //       ตามพระราชบัญญัติว่าด้วยความผิดอันเกิดจากการใช้เช็ค
      //       และยินยอมเสียดอกเบี้ย ในอัตราร้อยละ 15 ต่อปี
      //       ไปจนกว่าจะชำระแล้วเสร็จตามสัญญา
      //     </h5>
      //   </div>
      // </div>
      <div></div>
    );
  }
}
